import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a10780e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-sidebar sidebar-dark-primary elevation-4" }
const _hoisted_2 = { id: "sidebar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray mt-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "brand-text font-weight-light" }, "帳票テンプレート")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "sidebar mt-4"
}
const _hoisted_5 = { class: "list-unstyled components" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "list-unstyled" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-header" }, "連携設定", -1))
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_15 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "list-unstyled" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-header" }, "SSKCメニュー", -1))
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fuzoku_meisai_junsoku_menu = _resolveComponent("fuzoku-meisai-junsoku-menu")!
  const _component_fuzoku_meisai_kaikei_kijun_menu = _resolveComponent("fuzoku-meisai-kaikei-kijun-menu")!
  const _component_taishaku_taisho_menu = _resolveComponent("taishaku-taisho-menu")!
  const _component_soneki_keisan_menu = _resolveComponent("soneki-keisan-menu")!
  const _component_keiei_info_menu = _resolveComponent("keiei-info-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _hoisted_3,
      (!_ctx.userStatus.mustUpdateInitialPassword)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: "/top",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("TOP")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: "/period",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("会計期間")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/corporation-info",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("法人情報")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/update-password",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("パスワード更新")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: "/clear-cache",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("キャッシュクリア")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_fuzoku_meisai_junsoku_menu),
            _createVNode(_component_fuzoku_meisai_kaikei_kijun_menu),
            _createVNode(_component_taishaku_taisho_menu),
            _createVNode(_component_soneki_keisan_menu),
            _createVNode(_component_keiei_info_menu),
            _createElementVNode("div", null, [
              _createElementVNode("ul", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("li", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/link-oauth",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("API連携")
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.userStatus.enableAdminMenu || _ctx.userStatus.enableSystemMenu)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: "/admin/select-tenant",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("テナント選択")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.userStatus.enableAdminMenu)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/admin/user",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ユーザー")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.userStatus.enableSystemMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("ul", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("li", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        to: { name: 'Company' },
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("会社")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: { name: 'NoticeList' },
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("お知らせ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}